

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppClientProductModule, AppClientRootModule, AppFrameModule, AuthModule, CommonLayoutModule, CommonUIModule, CUSTOM_DATE_FORMAT, DictionaryProcessorService, TmcCustomDateAdapter, TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TmcAuthFrameComponent } from './tmc-auth-frame/tmc-auth-frame.component';

import commonDictionary from '@sdbn/common/assets/sdbn-common.dictionary.json';

import { TmcCommonModule } from '@sdbn/tmc-common';
import { TmcParkingProductModule } from '@sdbn/tmc-parking';
import { TmcYardProductModule } from '@sdbn/tmc-yard';
import { TmcVisitProductModule } from '@sdbn/tmc-visit';
import { ErpProductModule } from './../erp/erp.module';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    TmcAuthFrameComponent
  ],
  imports: [
    AuthModule,
    AppFrameModule,
    CommonLayoutModule,
    CommonUIModule,
    MatSidenavModule,
    BrowserModule,
    RouterModule.forRoot([]),
    BrowserAnimationsModule,
    AppRoutingModule,
    AppClientRootModule.forRoot(environment),

    /* product dependencies */
    AppClientProductModule,
    TmcCommonModule,
    TmcParkingProductModule,
    TmcYardProductModule,
    TmcVisitProductModule,
    ErpProductModule
  ],
  exports: [
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { autoFocus: true, disableClose: true, hasBackdrop: true } },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'de' },
    { provide: DateAdapter, useClass: TmcCustomDateAdapter }

  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(
    private translationService: TranslationService,
    dictionaryProcessorService: DictionaryProcessorService
  ) {
    console.log('processing dictionary', commonDictionary);
    this.translationService.addDictionaryEntries(dictionaryProcessorService.createDictionaryEntriesFromJSONTree(commonDictionary));
  }

}
